import { useState } from "react";

export function useCallHistory() {
  const [history, setHistory] = useState(() => {
    const saved = localStorage.getItem("callHist");
    return saved ? JSON.parse(saved) : [];
  });

  const updateCallHistory = (task) => {
    setHistory((prevHist) => {
      const index = prevHist.findIndex((item) => item.id === task.id);
      let updated;

      if (index !== -1) {
        //so that if a queue call missed by an agent during 1st ring is answered by him on 2nd ring, and sf mng pckg is there, then call hist should shown update recent tab ui and show answered call intead of a missed call as in sf task for missed call was updated
        updated = [...prevHist];
        updated[index] = { ...updated[index], ...task };
      } else {
        // Add new task at the front
        updated = [task, ...prevHist];
      }
      updated = updated.slice(0, 5);

      /*const exists = prevHist.some(item => item.id === task.id);
      if (exists) return prevHist;
      const updated = [task, ...prevHist].slice(0, 5);*/

      // Sort descending: latest first
      updated.sort((a, b) => b.startedAt - a.startedAt);

      localStorage.setItem("callHist", JSON.stringify(updated));
      return updated;
    });
  };

  return { history, updateCallHistory };
}
